import React from 'react';
import { TextField, SelectField, MenuItem, RaisedButton } from 'material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Header from "../../Header/Header";
import './AddRequests.css';
import { getYearData } from './AddExports/getYearData';
import debounce from 'lodash/debounce';
import closeRequest from '../../../Assets/Images/close-filters.svg';
import popupLogo from '../../../Assets/Images/logo.png';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { reactTranslateChangeLanguage } from 'translate-components';
import Translate from 'translate-components';
import RefreshIndicator from 'material-ui/RefreshIndicator';

/*
 * Component for adding requests.
 */



const muiTheme = getMuiTheme({
  fontFamily: 'Open Sans',
  datePicker: {
    headerColor: '#90CAF9',
    selectColor: '#90CAF9',
    color: '#90CAF9',
  },
  flatButton: {
    primaryTextColor: '#90CAF9',
  },
});

const style = {
  container: {
    position: 'relative',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

class AddRequests extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      clearGearResults: true,
      clearWorkshopResults: true,
      submitData: false,
      cityVal: false,
      outletVal: false,
      addressVal: false,
      glitchVal: false,
      phoneVal: false,
      gearVal: false,
      workShopCodePost: '',
      btnShow: false,
      messageId: true,
      glitchDatabaseID: '',
      requestId: '',
      errorTextPhone: '',
      errorTextOutlet: '',
      errorTextCity: '',
      value: props.value,
      loading: false,
      errorTextGlitch: '',
      errorTextAddress: '',
      loadingGear: false,
      gearOutput: [],
      locationsOutput: [],
      searchResults: [],
      selectedWorkshop: {
        name: '',
        city: '',
        address: '',
        contact_person: '',
        code: '',
        wholesaler: '',
        phone: '',
      },
      selectedGearItemID: '',
      fix: '',
      modelsProducers: [],
      selectedPhoneNumber: '',
      producers: [],
      selectedProducersAdd: '',
      selectedGear: '',
      selectedGearItem: {
        eq_id: '',
        inventory_no: "",
        model: "",
        production_year: "",
        serial_no: "",
      },
      data: {},

      submitValidationOutlet: false,
      submitValidateCity: false,
      submitValidateAddress: false,
      submitValidateModel: false,
      validationWraper: false,
    };

    /* Because of bad ux while using live search, I've used debounce.*/

    this.handleWorkshopChange = debounce(this.handleWorkshopChange.bind(this), 450);
    this.handleEquipmentChange = this.handleEquipmentChange.bind(this);
    this.handleEquipmentSelect = this.handleEquipmentSelect.bind(this);
    this.handleWorkshopSelect = this.handleWorkshopSelect.bind(this);
    this.equipmentSubmit = this.equipmentSubmit.bind(this);
    this.handleSubmitAllData = this.handleSubmitAllData.bind(this);
    this.resetWorkshop = this.resetWorkshop.bind(this);
    this.handleGlitch = this.handleGlitch.bind(this);
    this.resetEquipment = this.resetEquipment.bind(this);
    this.handleSelectedProducerAdd = this.handleSelectedProducerAdd.bind(this);
    this.workshopSubmit = this.workshopSubmit.bind(this);
    this.handlePhoneNumber = this.handlePhoneNumber.bind(this);
    this.allFieldsValidation = this.allFieldsValidation.bind(this);
    this.validateOutlet = this.validateOutlet.bind(this);
    this.handleMessageAppearClose = this.handleMessageAppearClose.bind(this);

    this.setLangEn = this.setLangEn.bind(this);
    this.setLangSr = this.setLangSr.bind(this);
  }

  handleMessageAppearClose() {
    this.setState({
      messageId: true,
      selectedPhoneNumber: '',
      fix: '',
      selectedGearItem: null,
      gearOutput: null,
      selectedWorkshop: null,
      validationWraper: null,
    });
    document.getElementById('submit-message').style.display = "none";
  }
  /*
   * Required fields form validation and getting values from required form elements, as error messages.
   */
  validateCommercNumber(event) {
    this.setState({
      selectedPhoneNumber: event.target.value,
    });
    if (event.target.value.match(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g)) {
      this.setState({
        errorTextPhone: '',
        phoneVal: true,
      })
    } else {
      this.setState({
        errorTextPhone: 'Unesite samo broj telefona, bez korišćenja karaktera.',
        phoneVal: false,
      });
    }
  }

  validateOwnerNumber = (event) => {
    this.setState({
      selectedWorkshop: {
        ...this.state.selectedWorkshop,
        phone: event.target.value,
      }
    });
    if (event.target.value.match(/^[0-9]/)) {
      this.setState({
        errorTextPhone: '',
        phoneVal: true,
      });
    } else {
      this.setState({
        errorTextPhone: 'Unesite samo broj telefona, bez korišćenja karaktera.',
        phoneVal: false,
      });
    }
  }


  validateOutlet = (event) => {

    this.setState({
      selectedWorkshop: {
        ...this.state.selectedWorkshop.name,
        name: event.target.value,

      }
    });

    if (event.target.value.match(/[0-9a-zA-Z]{1,}/)) {
      this.setState({
        errorTextOutlet: '',
        outletVal: true
      })
    }
    else {
      this.setState({
        errorTextOutlet: 'Minimalan broj karaktera za naziv lokala je 1.',
        outletVal: false,
      })
    }
  }

  validateGlitchText(event) {
    this.setState({ fix: event.target.value, });
    if (event.target.value.match(/[0-9a-zA-Z]{4,}/)) {
      this.setState({
        errorTextGlitch: '',
        glitchVal: true,
      })
    }
    else {
      this.setState({
        errorTextGlitch: 'Minimalan broj karaktera za prijavu kvara je 4.',
        glitchVal: false,
      })
    }
  }

  validateAddress = (event) => {
    this.setState({
      selectedWorkshop: {
        ...this.state.selectedWorkshop,
        address: event.target.value
      }
    });
    if (event.target.value.match(/[0-9a-zA-Z]{1,}/)) {
      this.setState({
        errorTextAddress: '',
        addressVal: true,
      })
    }
    else {
      this.setState({
        errorTextAddress: 'Minimalan broj karaktera za adresu je 1.',
        addressVal: false,
      })
    }
  }

  validateCity = (event) => {
    this.setState({
      selectedWorkshop: {
        ...this.state.selectedWorkshop,
        city: event.target.value
      }
    });
    if (event.target.value.match(/[0-9a-zA-Z]{3,}/)) {
      this.setState({
        errorTextCity: '',
        cityVal: true,
      })
    }
    else {
      this.setState({
        errorTextCity: 'Minimalan broj karaktera za grad je 3.',
        cityVal: false,
      })
    }
  }

  handleWorkshopChange(searchValue) {
    const searchResults = [];
    const userToken = localStorage.getItem('userToken');

    if (searchValue.length > 1) {
      this.setState({ loading: true });
      fetch(`${process.env.REACT_APP_API_HOST}webportal/locations_list/0/${searchValue}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-AUTH-TOKEN': userToken,
          'Accept': 'application/json'
        }
      })
        .then(response => response.json())
        .then(response => {
          response.forEach((item) => {

            if (item.name.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1) {
              searchResults.push(item);
            }
          });
          this.setState({
            searchResults,
            loading: false,
          });
        });
    }
  }


  componentWillUpdate() {

    setTimeout(() => {

      if (localStorage.getItem('selectedLang') === 'en') {
        this.setLangEn();
      }

      if (localStorage.getItem('selectedLang') === 'sr') {
        this.setLangSr();
      }

    }, 0)


  }


  componentDidMount(props) {
    const producers = [];

    const userToken = localStorage.getItem('userToken');

    fetch(`${process.env.REACT_APP_API_HOST}webportal/filter_catalog/service_requests`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-AUTH-TOKEN': userToken,
        'Accept': 'application/json'
      },
    })
      .then(response => response.json())
      .then(response => {
        producers.push(response.producers);
        this.setState({ producers: producers });
      });
    this.fetchModelsProducers();
    document.title = "Kreiranje naloga | Cool Beer";

    if (localStorage.getItem('selectedLang') === 'en') {
      this.setLangEn();
    }

    if (localStorage.getItem('selectedLang') === 'sr') {
      this.setLangSr();
    }
  }


  setLangSr() {
    reactTranslateChangeLanguage('sr');
  }

  setLangEn() {
    reactTranslateChangeLanguage('en');
  }
  /*
   *  Fetch results for selected model - type - producer.
   */

  handleEquipmentSelect(code) {
    const userToken = localStorage.getItem('userToken');
    fetch(
      `${process.env.REACT_APP_API_HOST}webportal/location_equipment/${code}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-AUTH-TOKEN': userToken,
          'Accept': 'application/json'
        }
      }).then(response => response.json())
      .then(response => {
        const gearOutput = [];
        response.forEach((gearItem) => {
          gearOutput.push(gearItem);
        });
        this.setState({ gearOutput });
      });
  }

  /*
   * Listed details about location object.
   */
  handleWorkshopSelect(e, code) {
    const userToken = localStorage.getItem('userToken');

    fetch(`${process.env.REACT_APP_API_HOST}webportal/location_details/${code}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-AUTH-TOKEN': userToken,
        'Accept': 'application/json'
      }
    })
      .then(response => response.json())
      .then(response => {
        let selectedWorkshop = {
          code: '',
          name: '',
          address: '',
          city: '',
          contact_person: '',
          phone: '',
          wholesaler: '',
        };
        if (Object.keys(response).length > 0) {
          const key = Object.keys(response)[0];
          const responseObject = response[key];
          Object.keys(responseObject).forEach(key => {
            if (responseObject[key] !== null) {
              selectedWorkshop[key] = responseObject[key];
            }
          });
        }
        this.setState({ selectedWorkshop });
      });
  }

  handlePhoneNumber(event) {
    this.setState({
      selectedPhoneNumber: event.target.value,
    })
  }

  handleEquipmentChange(event, index, value) {
    const newlySelectedGear = this.state.gearOutput.find(gear => gear.code === value);
    if (newlySelectedGear) {
      this.setState({ selectedGear: newlySelectedGear })
    }
  }

  handleSelectedProducerAdd = (event, index, Producer) => this.setState({
    selectedProducersAdd: Producer,
  });

  resetWorkshop = () => {
    this.setState({
      clearWorkshopResults: false,
      btnShow: false,
      selectedWorkshop: {
        code: '',
        name: '',
        address: '',
        city: '',
        contact_person: '',
        phone: '',
        wholesaler: '',
      },
      gearOutput: null,
      selectedGearItem: {
        eq_id: "798",
        serial_no: '',
        inventory_no: '',
        production_year: '',
        model: ''
      }
    })
    let selectMe = document.getElementById('form-add-wrap');
    let gearItems = document.getElementById('gear-wrapper-output');
    selectMe.style.display = "block";
    gearItems.style.display = "block";
  };
  resetEquipment = () => {
    this.setState({
      clearGearResults: false,
      selectedGearItem: {
        eq_id: '',
        serial_no: '',
        inventory_no: '',
        production_year: '',
        model: ''
      },
    })
    document.getElementById('gear-wrapper-output').style.display = "block";
  };

  allFieldsValidation() {
    if (this.state.phoneVal === true && this.state.cityVal === true && this.state.addressVal === true && this.state.glitchVal === true && this.state.outletVal === true) {
      this.setState({
        submitData: true,
      })
    }
    else {
      this.setState({
        submitData: false,
      })
    }
  }


  workshopSubmit() {
    let action = '';
    let method = '';
    const userToken = localStorage.getItem('userToken');
    let data = {
      outlet_id: this.state.selectedWorkshop.code,
      outlet_name: this.state.selectedWorkshop.name,
      outlet_address: this.state.selectedWorkshop.address,
      outlet_city: this.state.selectedWorkshop.city,
      outlet_owner: this.state.selectedWorkshop.contact_person,
      outlet_phone: this.state.selectedWorkshop.phone,
    };
    if (this.state.selectedWorkshop.code) {
      action = 'update';
      method = 'PUT';
    }
    else {
      data.outlet_id = this.state.workShopCodePost;
      action = 'create';
      method = 'POST';
    }
    return fetch(`${process.env.REACT_APP_API_HOST}webportal/location/${action}`, {
      method,
      credentials: "include",
      body: JSON.stringify(data),
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        'X-AUTH-TOKEN': userToken,
        'Content-Type': 'application/json',
      },
    }).then(response => response.json())
      .then(response => {
        let value = response[Object.keys(response)[0]];
        this.setState({ workShopCodePost: value });
      });
  };


  equipmentSubmit() {
    let action = '';
    let method = '';
    const userToken = localStorage.getItem('userToken');

    let data = {
      database_id: this.state.selectedGearItem.database_id,
      equipment_id: this.state.selectedGearItem.eq_id,
      eq_year: this.state.selectedGearItem.production_year,
      eq_inventory_no: this.state.selectedGearItem.inventory_no,
      outlet_id: this.state.selectedWorkshop.code,
      eq_serial_no: this.state.selectedGearItem.serial_no,
    };

    if (this.state.selectedGearItem.database_id) {
      data.equipment_id = this.state.selectedGearItem.eq_id;
      action = 'update';
      method = 'PUT'
    }


    else if (this.state.selectedWorkshop.code === '') {
      data.outlet_id = this.state.workShopCodePost;
      method = 'POST';
      action = 'create';
    }
    else {
      data.outlet_id = this.state.selectedWorkshop.code;
      method = 'POST';
      action = 'create';
    }

    return fetch(`${process.env.REACT_APP_API_HOST}webportal/equipment/${action}`, {
      method,
      credentials: "include",
      body: JSON.stringify(data),
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        'X-AUTH-TOKEN': userToken,
        'Content-Type': 'application/json',
      },
    }).then(response => response.json())
      .then(response => {
        let valueDatabaseId = response[Object.keys(response)[0]];
        this.setState({ glitchDatabaseID: valueDatabaseId });
      });
  };

  handleGlitch() {
    const userToken = localStorage.getItem('userToken');
    let glitchId = '';
    let outletValueGlitch = '';
    if (this.state.selectedWorkshop.code === '') {
      outletValueGlitch = this.state.workShopCodePost;
    }
    else {
      outletValueGlitch = this.state.selectedWorkshop.code;
    }

    if (this.state.selectedGearItem.database_id !== undefined) {
      glitchId = this.state.selectedGearItem.database_id;
    }
    else {
      glitchId = this.state.glitchDatabaseID;
    }

    return fetch(`${process.env.REACT_APP_API_HOST}webportal/service_request/create`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        outlet_id: outletValueGlitch,
        equipment_id: this.state.selectedGearItem.eq_id,
        eq_serial_no: this.state.selectedGearItem.serial_no,
        eq_year: this.state.selectedGearItem.production_year,
        database_id: glitchId,
        contact_person_phone: this.state.selectedPhoneNumber,
        c_malfunction_reported: this.state.fix,
      }),
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        'X-AUTH-TOKEN': userToken,
        'Content-Type': 'application/json',
      },
    }).then(response => response.json())
      .then(response => {
        let requestId = response[Object.keys(response)[0]];
        this.setState({ requestId: requestId, loading: true });
      });
  }


  fetchModelsProducers() {
    const modelsProducers = [];
    const userToken = localStorage.getItem('userToken');
    fetch(`${process.env.REACT_APP_API_HOST}webportal/models_and_producers`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        'X-AUTH-TOKEN': userToken,
        'Content-Type': 'application/json',
      },
    }).then(response => response.json())
      .then(response => {
        modelsProducers.push(response);
        this.setState({ modelsProducers: modelsProducers });
      }).catch(err => err);
  }

  async handleSubmitAllData() {

    // Final submit form validation for required fields - modal.
    if (this.state.selectedWorkshop.name !== '') {
      this.setState({ submitValidationOutlet: false })
    }
    if (this.state.selectedWorkshop.address !== '') {
      this.setState({ submitValidateCity: false })
    }
    if (this.state.selectedWorkshop.name !== '') {
      this.setState({ submitValidateAddress: false })
    }

    if ((this.state.selectedWorkshop.city !== '' && this.state.selectedWorkshop.name !== '' && this.state.selectedGearItem.eq_id !== '' && this.state.selectedWorkshop.address !== '' && this.state.fix !== '' && this.state.selectedPhoneNumber !== '') || (this.state.phoneVal === true && this.state.cityVal === true && this.state.addressVal === true && this.state.glitchVal === true && this.state.outletVal === true)) {
      await this.workshopSubmit();
      await this.equipmentSubmit();
      await this.handleGlitch();
      this.setState({
        messageId: false,
        searchResults: null,
        selectedGearItem: null,
        gearOutput: null,
        selectedPhoneNumber: null,
        fix: null,
        loading: false,
      });
      document.getElementById('submit-message').style.display = "block";
      let searchValueClear = document.getElementById('searchValue');
      searchValueClear.value = '';
    }
    else {
      this.setState({ validationWraper: true })
      if (this.state.selectedWorkshop.name === '') {
        this.setState({ submitValidationOutlet: true })
      }

      if (this.state.selectedWorkshop.address === '') {
        this.setState({ submitValidateAddress: true })
      }
      if (this.state.selectedWorkshop.city === '') {
        this.setState({ submitValidateCity: true })
      }
      if (this.state.selectedGearItem.eq_id === '') {
        this.setState({ submitValidateModel: true })
      }

    }
  }


  render() {
    // Style.
    const selectedStyle = {
      display: 'inline-block',
    };
    const loginInputStyle = {
      color: '#55aef6',
      borderColor: '#55aef6'
    };
    const floatLblStyle = {
      fontSize: 14,
    };


    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div style={{ position: "relative" }}>
          <div className="submit-message" id="submit-message">
            <img src={closeRequest} alt="close message" onClick={this.handleMessageAppearClose} className="img-close-requests" />
            <p className="request-message-confirm"><Translate>Vaš zahtev sa ID</Translate> {this.state.requestId}<Translate> je kreiran.</Translate></p>
            <img className={"submit-message-logo"} alt="coldbeer" src={popupLogo} />
          </div>
          <Header {...this.props} />
          {this.state.loading ? <div className="loader-search">   <RefreshIndicator
            size={40}
            left={10}
            top={0}
            loadingColor="#90caf9"
            status="loading"
            style={style.refresh} /> </div> : null}
          <div className="addRequets addRequets-local">
            <h4><Translate>Informacije o lokalu</Translate></h4>
            <p><Translate>Proverite da li je lokal u našoj bazi podataka:</Translate> </p>



            <TextField
              floatingLabelFocusStyle={loginInputStyle}
              id="searchValue"
              floatingLabelStyle={floatLblStyle}
              underlineFocusStyle={loginInputStyle}
              floatingLabelText={<Translate>Unesite ime lokala</Translate>}
              onChange={e => this.handleWorkshopChange(e.target.value)}
              name="searchValue"
            />
            <span className="addRequests__subtitle"><Translate>Molimo Vas unesite samo ime lokala, bez oznaka STR ili TR.</Translate></span>
            {
              this.state.clearWorkshopResults ? <div>
                {
                  this.state.searchResults && this.state.searchResults.map((selectedWorkshop) => {
                    return (
                      <div className="input-wrappers" key={selectedWorkshop.code}>
                        <a className="link--results" role="button" style={selectedStyle}
                          onClick={(e) => {
                            this.handleWorkshopSelect(e, selectedWorkshop.code);
                            this.handleEquipmentSelect(selectedWorkshop.code);
                            this.setState({
                              selectedWorkshop: {
                                city: selectedWorkshop.city,
                                name: selectedWorkshop.name,
                              },
                              btnShow: true,
                              searchResults: null,
                            }, )


                            document.getElementById('form-add-wrap').style.display = "block";

                          }
                          }
                        > {selectedWorkshop.name}
                        </a> , <p className="selectedWorkshop-address">{selectedWorkshop.address}</p> ,
                      <p className="selectedWorkshop-city">&nbsp; {selectedWorkshop.city} </p>
                      </div>
                    );
                  })
                }
              </div> : null
            }
            <RaisedButton
              className="workshop-create "
              label={
                <Translate>Kreirajte novi</Translate>
              }
              onClick={this.resetWorkshop}
            />
            <form>
              {
                this.state.selectedWorkshop && (
                  <MuiThemeProvider>
                    <div className="form-add-wrap" id="form-add-wrap">
                      <div>
                        <div className="input-wrappers">
                          {/* Selected workshop - name of workshop.*/}
                          <TextField
                            name="outlet_name"
                            floatingLabelFocusStyle={loginInputStyle}
                            underlineFocusStyle={loginInputStyle}
                            floatingLabelText={<Translate>Naziv lokala</Translate>}
                            floatingLabelFixed={true}
                            style={{ fontSize: 18 }}
                            errorText={this.state.errorTextOutlet}
                            value={this.state.selectedWorkshop.name}
                            onChange={(event) => {
                              this.setState({
                                selectedWorkshop: {
                                  ...this.state.selectedWorkshop,
                                  name: event.target.value,
                                }
                              })
                            }}
                          />
                          <TextField
                            name="outlet_address"
                            floatingLabelFocusStyle={loginInputStyle}
                            underlineFocusStyle={loginInputStyle}
                            floatingLabelFixed={true}
                            floatingLabelText={<Translate>Adresa lokala</Translate>}
                            style={{ display: "block", fontSize: 18 }}
                            errorText={this.state.errorTextAddress}
                            value={this.state.selectedWorkshop.address}
                            onChange={this.validateAddress.bind(this)}
                          />
                          {/* Selected workshop - city.*/}
                          <TextField
                            name="outlet_city"
                            floatingLabelFocusStyle={loginInputStyle}
                            underlineFocusStyle={loginInputStyle}
                            floatingLabelText={<Translate>Grad</Translate>}
                            floatingLabelFixed={true}
                            errorText={this.state.errorTextCity}
                            style={{ display: "block", fontSize: 18 }}
                            value={this.state.selectedWorkshop.city}
                            onChange={this.validateCity.bind(this)}
                          />
                          {/* Selected workshop - owner.*/}
                          <TextField
                            name="outlet_owner"
                            floatingLabelFocusStyle={loginInputStyle}
                            underlineFocusStyle={loginInputStyle}
                            floatingLabelText={<Translate>Vlasnik lokala</Translate>}
                            floatingLabelFixed={true}
                            style={{ display: "block", fontSize: 18 }}
                            value={this.state.selectedWorkshop.contact_person}
                            onChange={e => this.setState({
                              selectedWorkshop: {
                                ...this.state.selectedWorkshop,
                                contact_person: e.target.value
                              }
                            })}
                          />
                          {/* Selected workshop - owner contact phone number.*/}
                          <TextField
                            name="outlet_phone"
                            floatingLabelFocusStyle={loginInputStyle}
                            underlineFocusStyle={loginInputStyle}
                            floatingLabelText={<Translate>Telefon vlasnika</Translate>}
                            floatingLabelFixed={true}
                            style={{ display: "block", fontSize: 18 }}
                            errorText={this.state.errorTextPhone}
                            value={this.state.selectedWorkshop.phone}
                            onChange={this.validateOwnerNumber.bind(this)}
                          />
                        </div>
                      </div>
                    </div>
                  </MuiThemeProvider>
                )
              }
            </form>
          </div>
          <div className="addRequets">
            <h4 className="eq-item-title gear-info"><Translate>Informacije o opremi</Translate></h4>
            <p className="eq-item-subtitle gear-subtitle"><Translate>Završite informacije o lokalu pre informacija o opremi.</Translate></p>
            {
              this.state.clearGearResults ?
                // Preview of gear item before complete output.
                this.state.gearOutput && this.state.gearOutput.map((selectedGear, eq_id) => {
                  return (
                    <div className="input-wrappers" key={selectedGear.eq_id}>
                      <a className="link--results" role="button"
                        onClick={(e) => {
                          this.setState({ selectedGearItem: selectedGear });
                          document.getElementById('gear-wrapper-output').style.display = "block";
                        }}>
                        {selectedGear.type},
                      {selectedGear.model},
                      {selectedGear.producer},
                      {selectedGear.serial_no},
                      {selectedGear.inventory_no}
                      </a>
                    </div>
                  );
                }) : null
            }
            {
              this.state.btnShow === false ? null :
                <RaisedButton
                  name="newGear"
                  className="gear-create"
                  label={<Translate>Kreiraj novu opremu</Translate>}
                  onClick={this.resetEquipment}
                />
            }
            {this.state.loadingGear ?
              <div className="loader-equipment">
                <RefreshIndicator
                  size={40}
                  left={10}
                  top={0}
                  loadingColor="#90caf9"
                  status="loading"
                  style={style.refresh}
                />
              </div>
              : null}
            {
              this.state.selectedGearItem && (

                <div className="gearoutput-wrapper" id="gear-wrapper-output">
                  <div>
                    <SelectField
                      className="form-item form-item--proizvodjac"
                      floatingLabelFixed={true}
                      floatingLabelText={<Translate>Uređaj</Translate>}
                      autoWidth={true}
                      maxHeight={300}
                      style={{ fontSize: 18 }}

                      value={this.state.selectedGearItem.eq_id}
                      onChange={(event, index, value) => this.setState({
                        selectedGearItem: {
                          ...this.state.selectedGearItem,
                          eq_id: value
                        }
                      })}
                    >
                      {
                        this.state.modelsProducers && this.state.modelsProducers.map(producer => {
                          return Object.entries(producer).map(([index, producer]) => {
                            return <MenuItem key={index} value={index} primaryText={producer} />
                          })
                        })
                      }
                    </SelectField>
                  </div>
                  <div>
                    <TextField
                      name="serialNumber"
                      floatingLabelText={<Translate>Serijski broj</Translate>}
                      floatingLabelFocusStyle={loginInputStyle}
                      floatingLabelFixed={true}
                      underlineFocusStyle={loginInputStyle}
                      floatingLabelStyle={{ fontSize: 16 }}
                      value={this.state.selectedGearItem.serial_no}
                      onChange={e => this.setState({
                        selectedGearItem: {
                          ...this.state.selectedGearItem,
                          serial_no: e.target.value
                        }
                      })}
                    />
                  </div>
                  <div>
                    <TextField
                      name="inventoryNumber"
                      floatingLabelText={<Translate>Inventarni broj</Translate>}
                      floatingLabelFocusStyle={loginInputStyle}
                      underlineFocusStyle={loginInputStyle}
                      floatingLabelFixed={true}
                      floatingLabelStyle={{ fontSize: 16 }}
                      value={this.state.selectedGearItem.inventory_no}
                      onChange={e => this.setState({
                        selectedGearItem: {
                          ...this.state.selectedGearItem,
                          inventory_no: e.target.value
                        }
                      })}
                    />
                  </div>
                  <div>
                    <SelectField
                      floatingLabelFixed={true}
                      style={{ fontSize: 18 }}
                      maxHeight={300}
                      floatingLabelText={<Translate>Godina</Translate>}
                      value={this.state.selectedGearItem.production_year}
                      onChange={(event, index, value) => this.setState({
                        selectedGearItem: {
                          ...this.state.selectedGearItem,
                          production_year: value
                        }
                      })}
                    >
                      {
                        getYearData().map((year) => {
                          return (
                            <MenuItem key={year.id} value={year.value} primaryText={year.value} />
                          );
                        })
                      }
                    </SelectField>
                  </div>
                </div>
              )
            }
          </div>
          <div className="addRequets">

            {this.state.validationWraper ? <div className="final-validation-wraper" >
              {this.state.submitValidationOutlet ? <p>Polje naziv lokala je obavezno.</p> : null}
              {this.state.submitValidateCity ? <p>Polje grad je obavezno.</p> : null}
              {this.state.submitValidateAddress ? <p>Polje adresa je obavezno.</p> : null}
              {this.state.submitValidateModel ? <p> Informacija o opremi je obavezna. </p> : null}
            </div> : null
            }
            <h4 className="eq-item-title"><Translate>Detalji o kvaru</Translate></h4>
            <span className="addRequests__subtitle"><Translate>Odaberite lokal i uređaj pre prijave kvara.</Translate></span>
            <TextField
              multiLine={true}
              rows={2}
              floatingLabelFocusStyle={loginInputStyle}
              underlineFocusStyle={loginInputStyle}
              floatingLabelStyle={floatLblStyle}
              floatingLabelText={<Translate>Opis kvara</Translate>}
              rowsMax={29}
              value={this.state.fix}
              errorText={this.state.errorTextGlitch}
              disabled={this.state.selectedGearItem === ''}
              errorStyle={{ fontSize: 11 }}
              onChange={this.validateGlitchText.bind(this)}
              style={{ display: "block", fontSize: 18 }}
            />
            <TextField
              floatingLabelFocusStyle={loginInputStyle}
              underlineFocusStyle={loginInputStyle}
              style={{ fontSize: 18 }}
              floatingLabelStyle={floatLblStyle}
              onChange={this.validateCommercNumber.bind(this)}
              errorText={this.state.errorTextPhone}
              value={this.state.selectedPhoneNumber}
              disabled={this.state.glitchVal === false}
              errorStyle={{ fontSize: 11 }}
              floatingLabelText={<Translate>Telefon komercijaliste</Translate>}
            />

            <RaisedButton
              label={<Translate>Kreiraj</Translate>}
              backgroundColor="#90CAF9"
              labelColor="#ffffff"
              style={{ display: 'block', maxWidth: 170, marginTop: 20, marginBottom: 20 }}
              onClick={this.handleSubmitAllData}
              disabled={this.state.phoneVal === false}
            />
          </div>
        </div>
      </MuiThemeProvider >
    );
  }
}

export default AddRequests;



// WEBPACK FOOTER //
// ./src/Components/Requests/Add/AddRequests.jsx